import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <title>Home | Shalimar Hosiery Industries</title>
      <meta name="description" content="This is the home page" />
      <meta name="keywords" content="react, home, seo" />

      <div className="landing-wrapper">
        <SiteHeader className="loginsignup homepagelogo" />
        <Container fluid className="p-0">
          <div className="parent">
            <Link to="/collection" className="div2 section collection">
              <h2>Collection</h2>
              <p>View Collection</p>
            </Link>

            <Link to="/fabrics" className="div3 section fabrics">
              <h2>Fabrics</h2>
              <p>Feel them</p>
            </Link>

            <Link to="/contact" className="div4 section contact">
              <h2>Contact</h2>
              <p>Reach us</p>
            </Link>

            <Link to="/how-we-do-it" className="div5 section how">
              <h2>How We Do It</h2>
              <p>The Process</p>
            </Link>

            <Link to="/about" className="div6 section about">
              <h2>About Us</h2>
              <p>Know our story</p>
            </Link>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Home;
